import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link as RouterLink } from "react-router-dom";

export default function SearchPage() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!search.trim()) return;

    setLoading(true);

    const response = await fetch(
      "https://msdskserver.onrender.com/api/user/search",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // ❌ no token
        },
        body: JSON.stringify({ search }),
      }
    );

    const result = await response.json();
    setData(result.data || []);
    setLoading(false);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      {/* 🔔 Heading */}
      <Typography
        variant="h5"
        align="center"
        fontWeight="bold"
        gutterBottom
      >
        🔍 Notice Search
      </Typography>

      <Typography align="center" color="text.secondary" mb={3}>
        Admit Card, Result, Job, Scheme, Latest Notice Search Karein
      </Typography>

      {/* 🔍 Search Bar */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 4,
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <TextField
          fullWidth
          placeholder="Search by Title, Category, Name, Mobile, Status"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={handleSearch}
        >
          Search
        </Button>
      </Box>

      {/* ⏳ Loading */}
      {loading && (
        <Typography align="center">Searching notices...</Typography>
      )}

      {/* ❌ No Result */}
      {!loading && data.length === 0 && search && (
        <Typography align="center" color="error">
          No Notice Found
        </Typography>
      )}

      {/* 📋 Result Cards */}
     <Grid container spacing={2}>
  {data.map((item) => (
    <Grid item xs={12} sm={6} md={4} key={item._id}>
      <Card
        sx={{
          height: "100%",
          borderLeft: "5px solid #1976d2",
          cursor: "pointer",
        }}
      >
        <CardContent>
          <RouterLink
            to={`/notifactionview/${item._id}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Typography variant="h6" gutterBottom>
              {item.titlename}
            </Typography>
          </RouterLink>

          <Chip
            label={item.category}
            size="small"
            color="primary"
            sx={{ mb: 1 }}
          />

          <Typography
            variant="body2"
            sx={{
              mt: 1,
              color: item.status === "Active" ? "green" : "red",
              fontWeight: 600,
            }}
          >
            Status: {item.status}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

    </Box>
  );
}
